import {createContext, useContext, useState} from "react";

const LanguageContext = createContext();

export default function LanguageProvider({children}) {
  const [language, changeLanguage] = useState("rs");
  return (
    <LanguageContext.Provider value={{language, changeLanguage}}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
